// Wrapper around TikTok Pixel (window.ttq) — safe to call before the script loads.
export const TIKTOK_PIXEL_ID = "D7ICTG3C77UE891L3BM0";

export const ttq = (...args) => {
  if (typeof window !== "undefined" && window.ttq) {
    try {
      if (typeof window.ttq.track === "function") {
        // Execute via official API when available
        return null;
      }
    } catch (e) {
      // swallow
    }
  }
};

// Standard TikTok events: ViewContent, ClickButton, Search, AddToWishlist,
// AddToCart, InitiateCheckout, AddPaymentInfo, CompletePayment, PlaceAnOrder,
// Contact, Download, CompleteRegistration, Subscribe, SubmitForm, Lead
export const trackTikTokEvent = (event, params = {}) => {
  if (typeof window === "undefined" || !window.ttq) return;
  try {
    window.ttq.track(event, params);
  } catch (e) {
    // noop
  }
};

export const trackTikTokPageView = () => {
  if (typeof window === "undefined" || !window.ttq) return;
  try {
    window.ttq.page();
  } catch (e) {
    // noop
  }
};
